// extracted by mini-css-extract-plugin
export var chevronIcon = "_dm-2";
export var teamName = "_dm-1";
export var teamSwitcherButton = "_dm-0";